import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sessionActions } from '../store';
import { fetchDeviceCounts } from '../common/util/deviceData';

// Fleet-wide counts for the filter menu. Fetched once from
// GET /api/devices/counts when the page opens or the unit changes; after
// that the socket pushes a new set whenever the numbers change. Null until
// the first set lands.
export default (distanceUnit) => {
  const dispatch = useDispatch();
  const counts = useSelector((state) => state.session.counts);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const result = await fetchDeviceCounts(distanceUnit);
        if (!cancelled) {
          dispatch(sessionActions.updateCounts(result));
        }
      } catch (error) {
        // The menu keeps its last counts, or the rows it holds.
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [distanceUnit]);

  return counts;
};
